import { PresentationIcon, SquareArrowRightExitIcon } from 'lucide-react'

import type { PopoverContentProps, PopoverProps } from '../../../core'
import {
  Button,
  Popover,
  PopoverContent,
  PopoverTrigger,
  Stack,
} from '../../../core'
import { useDisplaySettings } from '../../features/admin/hooks/useDisplaySettings'
import { useDisableDemoMode } from '../../features/admin/hooks/useSetDemoMode'

export interface DemoModeIndicatorProps extends Omit<PopoverProps, 'children'> {
  contentAlign?: PopoverContentProps['align']
}

export function DemoModeIndicator({
  contentAlign = 'start',
  ...props
}: DemoModeIndicatorProps) {
  const [displaySettings] = useDisplaySettings()
  const disableDemoMode = useDisableDemoMode()

  if (!displaySettings.demo_mode?.account_slug) {
    return null
  }

  return (
    <Popover {...props}>
      <PopoverTrigger asChild>
        <Button variant="brand" size="xs" startIcon={<PresentationIcon />}>
          {`Demo`}
        </Button>
      </PopoverTrigger>
      <PopoverContent align={contentAlign}>
        <Stack gap="sm">
          <p className="text-tremor-content text-sm">{`Blurs PHI and PII on this device.`}</p>
          <Button
            size="sm"
            endIcon={<SquareArrowRightExitIcon />}
            onClick={() => {
              disableDemoMode()
            }}
          >
            {`Exit demo mode`}
          </Button>
        </Stack>
      </PopoverContent>
    </Popover>
  )
}
